import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ISiparisParsiyelDetayv2_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ISiparisParsiyelDetayv2_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  Get_Helpers_UserInfoByUserName: any[];
  Get_Helpers_UserInfoByUserName_dummy: any[];
  Get_Tanim_MusteriListe_LTL: any[];
  Get_Tanim_MusteriListe_LTL_dummy: any[];
  Get_Tanim_UrunListe: any[];
  Get_Tanim_UrunListe_dummy: any[];
  Get_NakliyeSicaklik_Liste: any[];
  Get_NakliyeSicaklik_Liste_dummy: any[];
  Siparis_Get_ParsiyelDetayById_v2: any[];
  Siparis_Get_ParsiyelDetayById_v2_dummy: any[];
  Get_Tanim_MusteriNoktaListe: any[];
  Get_Tanim_MusteriNoktaListe_dummy: any[];
  Get_Tanim_MusteriNoktaListe_Target: any[];
  Get_Tanim_MusteriNoktaListe_Target_dummy: any[];
  Siparis_Get_ParsiyelHareket_ByIdv2: any[];
  Siparis_Get_ParsiyelHareket_ByIdv2_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  GoBack: any;
  GoBack_dummy: any;
  Siparis_Add_Parsiyelv2: number;
  Siparis_Add_Parsiyelv2_dummy: number;
  isComp170782Visible: "visible" | "hidden";
  isComp139041Enabled: "enabled" | "disabled";
}

export class SiparisParsiyelDetayv2_ScreenBase extends React.PureComponent<
  ISiparisParsiyelDetayv2_ScreenProps,
  any
> {
  siparisparsiyeldetayv2_792514_value_kuikaDateRef: React.RefObject<any>;
  siparisparsiyeldetayv2_5696_value_kuikaAutoCompleteRef: React.RefObject<any>;
  siparisparsiyeldetayv2_517121_value_kuikaAutoCompleteRef: React.RefObject<any>;
  siparisparsiyeldetayv2_661366_value_kuikaAutoCompleteRef: React.RefObject<any>;
  siparisparsiyeldetayv2_315840_value_kuikaAutoCompleteRef: React.RefObject<any>;
  siparisparsiyeldetayv2_535525_value_kuikaAutoCompleteRef: React.RefObject<any>;
  siparisparsiyeldetayv2_459431_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "585b6303-ac4a-473f-8893-c915ede3bf84",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "00453f40-4009-42c1-bde9-b9a675f5035f",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 449703,
          PropertyName: "value",
          Value: "Aruna Nakliye Yönetim Portalı",
        },
        { Id: 2541, PropertyName: "tab", Value: "Sipariş Genel Bilgileri" },
        { Id: 753721, PropertyName: "value", Value: "Durumu" },
        { Id: 884296, PropertyName: "value", Value: "Sipariş No" },
        { Id: 244943, PropertyName: "value", Value: "Sipariş Tarihi" },
        { Id: 792514, PropertyName: "placeholder", Value: "Gün Seçiniz" },
        { Id: 914051, PropertyName: "value", Value: "Müşteri" },
        {
          Id: 5696,
          PropertyName: "placeholder",
          Value: "Aramak için yazınız...",
        },
        { Id: 795230, PropertyName: "value", Value: "Müşteri Sipariş No" },
        { Id: 769540, PropertyName: "value", Value: "Taşınacak Ürün" },
        {
          Id: 517121,
          PropertyName: "placeholder",
          Value: "Aramak için yazınız ...",
        },
        { Id: 113863, PropertyName: "value", Value: "Tanımsız Ürün" },
        { Id: 873783, PropertyName: "value", Value: "Çıkış Noktası" },
        {
          Id: 661366,
          PropertyName: "placeholder",
          Value: "Aramak için yazınız...",
        },
        { Id: 421868, PropertyName: "value", Value: "Varış Noktası" },
        {
          Id: 315840,
          PropertyName: "placeholder",
          Value: "Aramak için yazınız...",
        },
        { Id: 833942, PropertyName: "value", Value: "Palet Sayısı" },
        { Id: 804306, PropertyName: "value", Value: "Palet Ebat" },
        { Id: 793888, PropertyName: "value", Value: "Fiyat" },
        { Id: 866548, PropertyName: "placeholder", Value: "0" },
        { Id: 540150, PropertyName: "value", Value: "Nakliye Derecesi" },
        {
          Id: 535525,
          PropertyName: "placeholder",
          Value: "Aramak için yazınız...",
        },
        { Id: 920718, PropertyName: "value", Value: "Brüt Ağırlık" },
        { Id: 977468, PropertyName: "placeholder", Value: "0" },
        { Id: 843323, PropertyName: "value", Value: "Ürün Miktarı" },
        { Id: 45887, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 931509, PropertyName: "value", Value: "Koli Adedi" },
        { Id: 121251, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 440103, PropertyName: "value", Value: "Ön Toplama" },
        { Id: 276947, PropertyName: "value", Value: "Mikro Dağıtım" },
        { Id: 8606, PropertyName: "label", Value: "Vazgeç" },
        { Id: 205082, PropertyName: "label", Value: "Kaydet" },
        { Id: 206670, PropertyName: "tab", Value: "Hareketler" },
        { Id: 155309, PropertyName: "title", Value: "İşlem Tarihi" },
        { Id: 922005, PropertyName: "value", Value: "[datafield:lastupdated]" },
        { Id: 845361, PropertyName: "title", Value: "Açıklama" },
        { Id: 565458, PropertyName: "value", Value: "[datafield:aciklama]" },
        { Id: 987704, PropertyName: "title", Value: "Kullanıcı Adı" },
        { Id: 952465, PropertyName: "value", Value: "[datafield:username]" },
        { Id: 434775, PropertyName: "title", Value: "Ad Soyad" },
        { Id: 321531, PropertyName: "value", Value: "[datafield:adsoyad]" },
        { Id: 147936, PropertyName: "tab", Value: "Ek Hizmetler" },
        { Id: 804125, PropertyName: "tab", Value: "Masraflar" },
        { Id: 898178, PropertyName: "tab", Value: "Belgeler" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.siparisparsiyeldetayv2_139041_value_kuikaTextInputRef =
      React.createRef();
    this.siparisparsiyeldetayv2_792514_value_kuikaDateRef = React.createRef();
    this.siparisparsiyeldetayv2_5696_value_kuikaAutoCompleteRef =
      React.createRef();
    this.siparisparsiyeldetayv2_54902_value_kuikaTextInputRef =
      React.createRef();
    this.siparisparsiyeldetayv2_517121_value_kuikaAutoCompleteRef =
      React.createRef();
    this.siparisparsiyeldetayv2_170782_value_kuikaTextInputRef =
      React.createRef();
    this.siparisparsiyeldetayv2_661366_value_kuikaAutoCompleteRef =
      React.createRef();
    this.siparisparsiyeldetayv2_315840_value_kuikaAutoCompleteRef =
      React.createRef();
    this.siparisparsiyeldetayv2_387232_value_kuikaTextInputRef =
      React.createRef();
    this.siparisparsiyeldetayv2_516629_value_kuikaTextInputRef =
      React.createRef();
    this.siparisparsiyeldetayv2_866548_value_kuikaTextInputRef =
      React.createRef();
    this.siparisparsiyeldetayv2_535525_value_kuikaAutoCompleteRef =
      React.createRef();
    this.siparisparsiyeldetayv2_977468_value_kuikaTextInputRef =
      React.createRef();
    this.siparisparsiyeldetayv2_45887_value_kuikaTextInputRef =
      React.createRef();
    this.siparisparsiyeldetayv2_121251_value_kuikaTextInputRef =
      React.createRef();
    this.siparisparsiyeldetayv2_459431_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      Get_Helpers_UserInfoByUserName: [],
      Get_Tanim_MusteriListe_LTL: [],
      Get_Tanim_UrunListe: [],
      Get_NakliyeSicaklik_Liste: [],
      Siparis_Get_ParsiyelDetayById_v2: [],
      Get_Tanim_MusteriNoktaListe: [],
      Get_Tanim_MusteriNoktaListe_Target: [],
      Siparis_Get_ParsiyelHareket_ByIdv2: [],
      SetValueOf: "",
      GoBack: "",
      Siparis_Add_Parsiyelv2: 0,
      isComp170782Visible: "hidden",
      isComp139041Enabled: "disabled",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("siparisparsiyeldetayv2", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.SiparisParsiyelDetayv2PageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("siparisparsiyeldetayv2", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("siparisparsiyeldetayv2", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.SiparisParsiyelDetayv2PageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      siparisparsiyeldetayv2_139041_value:
        this.state.Siparis_Get_ParsiyelDetayById_v2?.at?.(0)?.siparisNo ??
        undefined,
      siparisparsiyeldetayv2_792514_value:
        this.state.Siparis_Get_ParsiyelDetayById_v2?.at?.(0)?.tarih ??
        undefined,
      siparisparsiyeldetayv2_5696_value:
        this.state.Siparis_Get_ParsiyelDetayById_v2?.at?.(0)?.musteriId ??
        undefined,
      siparisparsiyeldetayv2_54902_value:
        this.state.Siparis_Get_ParsiyelDetayById_v2?.at?.(0)
          ?.musteriSiparisNo ?? undefined,
      siparisparsiyeldetayv2_517121_value:
        this.state.Siparis_Get_ParsiyelDetayById_v2?.at?.(0)?.urunId ??
        undefined,
      siparisparsiyeldetayv2_278003_checked: false,
      siparisparsiyeldetayv2_170782_value:
        this.state.Siparis_Get_ParsiyelDetayById_v2?.at?.(0)?.urunAciklama ??
        undefined,
      siparisparsiyeldetayv2_661366_value:
        this.state.Siparis_Get_ParsiyelDetayById_v2?.at?.(0)?.cikisNoktasi ??
        undefined,
      siparisparsiyeldetayv2_315840_value:
        this.state.Siparis_Get_ParsiyelDetayById_v2?.at?.(0)?.varisNoktasi ??
        undefined,
      siparisparsiyeldetayv2_387232_value:
        this.state.Siparis_Get_ParsiyelDetayById_v2?.at?.(0)?.paletSayisi ??
        undefined,
      siparisparsiyeldetayv2_516629_value:
        this.state.Siparis_Get_ParsiyelDetayById_v2?.at?.(0)?.paletEbat ??
        undefined,
      siparisparsiyeldetayv2_866548_value:
        this.state.Siparis_Get_ParsiyelDetayById_v2?.at?.(0)?.fiyat ??
        undefined,
      siparisparsiyeldetayv2_535525_value:
        this.state.Siparis_Get_ParsiyelDetayById_v2?.at?.(0)?.nakliyeSicaklik ??
        undefined,
      siparisparsiyeldetayv2_977468_value:
        this.state.Siparis_Get_ParsiyelDetayById_v2?.at?.(0)?.brutAgirlik ??
        undefined,
      siparisparsiyeldetayv2_45887_value:
        this.state.Siparis_Get_ParsiyelDetayById_v2?.at?.(0)?.urunMiktar ??
        undefined,
      siparisparsiyeldetayv2_121251_value:
        this.state.Siparis_Get_ParsiyelDetayById_v2?.at?.(0)?.koliAdedi ??
        undefined,
      siparisparsiyeldetayv2_799352_value:
        this.state.Siparis_Get_ParsiyelDetayById_v2?.at?.(0)?.onToplamaVar ??
        undefined,
      siparisparsiyeldetayv2_263000_value:
        this.state.Siparis_Get_ParsiyelDetayById_v2?.at?.(0)?.mikroDagitimVar ??
        undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  checkTabErrors = () => {
    document.querySelectorAll(".rc-tabs-tab").forEach((tab) => {
      (tab as HTMLElement).style.color = "";
    });

    const tabPanes = document.querySelectorAll(".rc-tabs-tabpane");
    const tabs = document.querySelectorAll(".rc-tabs-tab");

    tabPanes.forEach((tabPane, index) => {
      const uniquePaneId = `rc-tabs-tabpane-${index}`;
      if (!tabPane.hasAttribute("id")) {
        tabPane.setAttribute("id", uniquePaneId);
      }

      const uniqueTabId = `rc-tabs-tab-${index}`;
      if (tabs[index]) {
        if (!tabs[index].hasAttribute("id")) {
          tabs[index].setAttribute("id", uniqueTabId);
        }
        tabs[index].setAttribute("aria-controls", uniquePaneId);
      }
    });

    const errorElements = document.querySelectorAll(
      ".rc-tabs .ant-form-item-explain-error"
    );

    const tabsWithErrors = new Set<string>();

    errorElements.forEach((errorElement) => {
      const tabPane = errorElement.closest(".rc-tabs-tabpane");
      if (tabPane && tabPane.id) {
        tabsWithErrors.add(tabPane.id);
      }
    });

    tabsWithErrors.forEach((tabPaneId) => {
      const tab = document.querySelector(
        `.rc-tabs-tab[aria-controls="${tabPaneId}"]`
      );
      if (tab) {
        (tab as HTMLElement).style.color = "red";
      }
    });
  };

  SiparisParsiyelDetayv2PageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      UserId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].id
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].id
            : null
        ),
        "Guid"
      ),
      UserId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].id
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].id
            : null
        ),
        "Guid"
      ),
      UserId_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].id
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].id
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SiparisParsiyelDetayv2/SiparisParsiyelDetayv2PageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Helpers_UserInfoByUserName =
      result?.data.get_Helpers_UserInfoByUserName;
    stateVars.Get_Tanim_MusteriListe_LTL =
      result?.data.get_Tanim_MusteriListe_LTL;

    formVars.siparisparsiyeldetayv2_5696_options =
      stateVars.Get_Tanim_MusteriListe_LTL;
    stateVars.Get_Tanim_UrunListe = result?.data.get_Tanim_UrunListe;

    formVars.siparisparsiyeldetayv2_517121_options =
      stateVars.Get_Tanim_UrunListe;
    stateVars.Get_NakliyeSicaklik_Liste =
      result?.data.get_NakliyeSicaklik_Liste;

    formVars.siparisparsiyeldetayv2_535525_options =
      stateVars.Get_NakliyeSicaklik_Liste;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].id
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].id
            : null
        ),
        "Guid"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.SiparisId ?? this.props.screenInputs.siparisid,
        "Guid"
      ),
    };

    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.SiparisId ?? this.props.screenInputs.siparisid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "SiparisParsiyelDetayv2/SiparisParsiyelDetayv2PageInit1_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.Siparis_Get_ParsiyelDetayById_v2 =
        result?.data.siparis_Get_ParsiyelDetayById_v2;
      formVars.siparisparsiyeldetayv2_564094_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
              ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].durumAciklama
              : null
            : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].durumAciklama
            : null
        );
      formVars.siparisparsiyeldetayv2_139041_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
              ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].siparisNo
              : null
            : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].siparisNo
            : null
        );
      formVars.siparisparsiyeldetayv2_792514_value = ReactSystemFunctions.value(
        this,
        stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
          ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].tarih
            : null
          : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
          ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].tarih
          : null
      );
      formVars.siparisparsiyeldetayv2_5696_value =
        stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
          ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].musteriId
            : null
          : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
          ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].musteriId
          : null;
      formVars.siparisparsiyeldetayv2_54902_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
              ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].musteriSiparisNo
              : null
            : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].musteriSiparisNo
            : null
        );
      formVars.siparisparsiyeldetayv2_517121_value =
        stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
          ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].urunId
            : null
          : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
          ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].urunId
          : null;
      formVars.siparisparsiyeldetayv2_170782_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
              ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].urunAciklama
              : null
            : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].urunAciklama
            : null
        );
      formVars.siparisparsiyeldetayv2_661366_value =
        stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
          ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].cikisNoktasi
            : null
          : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
          ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].cikisNoktasi
          : null;
      formVars.siparisparsiyeldetayv2_315840_value =
        stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
          ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].varisNoktasi
            : null
          : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
          ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].varisNoktasi
          : null;
      formVars.siparisparsiyeldetayv2_387232_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
              ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].paletSayisi
              : null
            : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].paletSayisi
            : null
        );
      formVars.siparisparsiyeldetayv2_516629_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
              ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].paletEbat
              : null
            : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].paletEbat
            : null
        );
      formVars.siparisparsiyeldetayv2_866548_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
              ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].fiyat
              : null
            : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].fiyat
            : null
        );
      formVars.siparisparsiyeldetayv2_535525_value =
        stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
          ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].nakliyeSicaklik
            : null
          : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
          ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].nakliyeSicaklik
          : null;
      formVars.siparisparsiyeldetayv2_977468_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
              ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].brutAgirlik
              : null
            : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].brutAgirlik
            : null
        );
      formVars.siparisparsiyeldetayv2_45887_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
              ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].urunMiktar
              : null
            : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].urunMiktar
            : null
        );
      formVars.siparisparsiyeldetayv2_121251_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
              ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].koliAdedi
              : null
            : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].koliAdedi
            : null
        );
      formVars.siparisparsiyeldetayv2_799352_value = ReactSystemFunctions.value(
        this,
        stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
          ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].onToplamaVar
            : null
          : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
          ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].onToplamaVar
          : null
      );
      formVars.siparisparsiyeldetayv2_263000_value = ReactSystemFunctions.value(
        this,
        stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
          ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].mikroDagitimVar
            : null
          : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
          ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].mikroDagitimVar
          : null
      );
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit2_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      MusteriId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisparsiyeldetayv2_5696_value",
            "value",
            "Get_Tanim_MusteriListe_LTL",
            "id",
            ""
          )
        ),
        "Guid"
      ),
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].id
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].id
            : null
        ),
        "Guid"
      ),
      MusteriId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisparsiyeldetayv2_5696_value",
            "value",
            "Get_Tanim_MusteriListe_LTL",
            "id",
            ""
          )
        ),
        "Guid"
      ),
      UserId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].id
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].id
            : null
        ),
        "Guid"
      ),
      SiparisNo_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
              ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].siparisNo
              : null
            : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].siparisNo
            : null
        ),
        "number"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SiparisParsiyelDetayv2/SiparisParsiyelDetayv2PageInit2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Tanim_MusteriNoktaListe =
      result?.data.get_Tanim_MusteriNoktaListe;

    formVars.siparisparsiyeldetayv2_661366_options =
      stateVars.Get_Tanim_MusteriNoktaListe;
    stateVars.Get_Tanim_MusteriNoktaListe_Target =
      result?.data.get_Tanim_MusteriNoktaListe_Target;

    formVars.siparisparsiyeldetayv2_315840_options =
      stateVars.Get_Tanim_MusteriNoktaListe_Target;
    stateVars.Siparis_Get_ParsiyelHareket_ByIdv2 =
      result?.data.siparis_Get_ParsiyelHareket_ByIdv2;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.SiparisId ?? this.props.screenInputs.siparisid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.siparisparsiyeldetayv2_564094_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
              ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].durumAciklama
              : null
            : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].durumAciklama
            : null
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit4_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit4_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.SiparisId ?? this.props.screenInputs.siparisid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.siparisparsiyeldetayv2_139041_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
              ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].siparisNo
              : null
            : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].siparisNo
            : null
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit5_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit5_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.SiparisId ?? this.props.screenInputs.siparisid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.siparisparsiyeldetayv2_792514_value = ReactSystemFunctions.value(
        this,
        stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
          ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].tarih
            : null
          : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
          ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].tarih
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit6_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit6_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit6_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit7_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit7_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.SiparisId ?? this.props.screenInputs.siparisid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.siparisparsiyeldetayv2_5696_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
              ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].musteriId
              : null
            : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].musteriId
            : null
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit8_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit8_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit8_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_5696 =
      stateVars.Get_Tanim_MusteriListe_LTL ??
      this.state.Get_Tanim_MusteriListe_LTL;
    stateVars.dataSource_5696 =
      stateVars.Get_Tanim_MusteriListe_LTL ??
      this.state.Get_Tanim_MusteriListe_LTL;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit9_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit9_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.SiparisId ?? this.props.screenInputs.siparisid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.siparisparsiyeldetayv2_54902_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
              ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].musteriSiparisNo
              : null
            : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].musteriSiparisNo
            : null
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit10_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit10_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit10_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit11_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.SiparisId ?? this.props.screenInputs.siparisid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.siparisparsiyeldetayv2_517121_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
              ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].urunId
              : null
            : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].urunId
            : null
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit12_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit12_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit12_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_517121 =
      stateVars.Get_Tanim_UrunListe ?? this.state.Get_Tanim_UrunListe;
    stateVars.dataSource_517121 =
      stateVars.Get_Tanim_UrunListe ?? this.state.Get_Tanim_UrunListe;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit13_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit13_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.SiparisId ?? this.props.screenInputs.siparisid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.siparisparsiyeldetayv2_170782_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
              ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].urunAciklama
              : null
            : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].urunAciklama
            : null
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit14_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit14_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit14_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp170782Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisparsiyeldetayv2_278003_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        true
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit15_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit15_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.SiparisId ?? this.props.screenInputs.siparisid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.siparisparsiyeldetayv2_661366_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
              ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].cikisNoktasi
              : null
            : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].cikisNoktasi
            : null
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit16_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit16_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit16_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_661366 =
      stateVars.Get_Tanim_MusteriNoktaListe ??
      this.state.Get_Tanim_MusteriNoktaListe;
    stateVars.dataSource_661366 =
      stateVars.Get_Tanim_MusteriNoktaListe ??
      this.state.Get_Tanim_MusteriNoktaListe;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit17_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit17_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.SiparisId ?? this.props.screenInputs.siparisid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.siparisparsiyeldetayv2_315840_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
              ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].varisNoktasi
              : null
            : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].varisNoktasi
            : null
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit18_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit18_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit18_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_315840 =
      stateVars.Get_Tanim_MusteriNoktaListe_Target ??
      this.state.Get_Tanim_MusteriNoktaListe_Target;
    stateVars.dataSource_315840 =
      stateVars.Get_Tanim_MusteriNoktaListe_Target ??
      this.state.Get_Tanim_MusteriNoktaListe_Target;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit19_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit19_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.SiparisId ?? this.props.screenInputs.siparisid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.siparisparsiyeldetayv2_387232_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
              ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].paletSayisi
              : null
            : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].paletSayisi
            : null
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit20_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit20_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit20_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.SiparisId ?? this.props.screenInputs.siparisid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.siparisparsiyeldetayv2_516629_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
              ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].paletEbat
              : null
            : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].paletEbat
            : null
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit21_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit21_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit21_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.SiparisId ?? this.props.screenInputs.siparisid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.siparisparsiyeldetayv2_866548_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
              ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].fiyat
              : null
            : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].fiyat
            : null
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit22_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit22_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit22_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit23_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit23_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.SiparisId ?? this.props.screenInputs.siparisid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.siparisparsiyeldetayv2_535525_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
              ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].nakliyeSicaklik
              : null
            : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].nakliyeSicaklik
            : null
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit24_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit24_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit24_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_535525 =
      stateVars.Get_NakliyeSicaklik_Liste ??
      this.state.Get_NakliyeSicaklik_Liste;
    stateVars.dataSource_535525 =
      stateVars.Get_NakliyeSicaklik_Liste ??
      this.state.Get_NakliyeSicaklik_Liste;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit25_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit25_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.SiparisId ?? this.props.screenInputs.siparisid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.siparisparsiyeldetayv2_977468_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
              ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].brutAgirlik
              : null
            : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].brutAgirlik
            : null
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit26_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit26_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit26_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.SiparisId ?? this.props.screenInputs.siparisid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.siparisparsiyeldetayv2_45887_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
              ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].urunMiktar
              : null
            : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].urunMiktar
            : null
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit27_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit27_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit27_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.SiparisId ?? this.props.screenInputs.siparisid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.siparisparsiyeldetayv2_121251_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
              ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].koliAdedi
              : null
            : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].koliAdedi
            : null
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit28_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit28_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit28_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.SiparisId ?? this.props.screenInputs.siparisid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.siparisparsiyeldetayv2_799352_value = ReactSystemFunctions.value(
        this,
        stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
          ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].onToplamaVar
            : null
          : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
          ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].onToplamaVar
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit29_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit29_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit29_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.SiparisId ?? this.props.screenInputs.siparisid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.siparisparsiyeldetayv2_263000_value = ReactSystemFunctions.value(
        this,
        stateVars.Siparis_Get_ParsiyelDetayById_v2 !== undefined
          ? stateVars.Siparis_Get_ParsiyelDetayById_v2?.length > 0
            ? stateVars.Siparis_Get_ParsiyelDetayById_v2[0].mikroDagitimVar
            : null
          : this.state.Siparis_Get_ParsiyelDetayById_v2?.length > 0
          ? this.state.Siparis_Get_ParsiyelDetayById_v2[0].mikroDagitimVar
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit30_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SiparisParsiyelDetayv2PageInit30_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2PageInit30_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_459431 =
      stateVars.Siparis_Get_ParsiyelHareket_ByIdv2 ??
      this.state.Siparis_Get_ParsiyelHareket_ByIdv2;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  SiparisParsiyelDetayv2Component_830317_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaTipi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].firmaTipi
            : null
        ),
        "1"
      )
    ) {
      KuikaAppManager.showSpinner(this);

      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        this.SiparisParsiyelDetayv2Component_830317_onClick1_,
        "SiparisParsiyelDetayv2",
        "LeftMenu",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "364603",
        null,
        "left",
        "true",
        "380px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.SiparisParsiyelDetayv2Component_830317_onClick1_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2Component_830317_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaTipi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].firmaTipi
            : null
        ),
        "2"
      )
    ) {
      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        undefined,
        "SiparisParsiyelDetayv2",
        "LeftMenuYukVeren",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "886136",
        null,
        "left",
        "true",
        "380px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  SiparisParsiyelDetayv2Component_5696_onBlur = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      MusteriId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisparsiyeldetayv2_5696_value",
            "value",
            "Get_Tanim_MusteriListe_LTL",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].id
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].id
            : null
        ),
        "Guid"
      ),
      MusteriId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisparsiyeldetayv2_5696_value",
            "value",
            "Get_Tanim_MusteriListe_LTL",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      UserId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].id
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].id
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SiparisParsiyelDetayv2/SiparisParsiyelDetayv2Component_5696_onBlur",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Tanim_MusteriNoktaListe =
      result?.data.get_Tanim_MusteriNoktaListe;

    formVars.siparisparsiyeldetayv2_661366_options =
      stateVars.Get_Tanim_MusteriNoktaListe;
    stateVars.Get_Tanim_MusteriNoktaListe_Target =
      result?.data.get_Tanim_MusteriNoktaListe_Target;

    formVars.siparisparsiyeldetayv2_315840_options =
      stateVars.Get_Tanim_MusteriNoktaListe_Target;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.SiparisParsiyelDetayv2Component_5696_onBlur1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2Component_5696_onBlur1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_661366 =
      stateVars.Get_Tanim_MusteriNoktaListe ??
      this.state.Get_Tanim_MusteriNoktaListe;
    stateVars.dataSource_661366 =
      stateVars.Get_Tanim_MusteriNoktaListe ??
      this.state.Get_Tanim_MusteriNoktaListe;

    stateVars.dataSource_315840 =
      stateVars.Get_Tanim_MusteriNoktaListe_Target ??
      this.state.Get_Tanim_MusteriNoktaListe_Target;
    stateVars.dataSource_315840 =
      stateVars.Get_Tanim_MusteriNoktaListe_Target ??
      this.state.Get_Tanim_MusteriNoktaListe_Target;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisParsiyelDetayv2Component_278003_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisparsiyeldetayv2_278003_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        false
      )
    ) {
      KuikaAppManager.showSpinner(this);

      stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "siparisparsiyeldetayv2_170782_value",
          "string"
        ),
        "",
        null,
        null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.SiparisParsiyelDetayv2Component_278003_onChange1_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.SiparisParsiyelDetayv2Component_278003_onChange1_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2Component_278003_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp170782Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisparsiyeldetayv2_278003_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        true
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisParsiyelDetayv2Component_8606_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "72f0572a_c5d2_701e_3737_33e0e1b939a1_confirmation",
        this.defaultML,
        "Kaydedilmemş veriler iptal edilecek. Emin misiniz ?"
      ),
      "poppins",
      "",
      "",
      "#246dff"
    );

    if (stateVars.Confirm) {
      KuikaAppManager.showSpinner(this);

      stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  SiparisParsiyelDetayv2Component_205082_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CikisNoktasi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisparsiyeldetayv2_661366_value",
            "value",
            "Get_Tanim_MusteriNoktaListe",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      Durum_0: ReactSystemFunctions.convertToTypeByName(0, "number"),
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].id
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].id
            : null
        ),
        "Guid"
      ),
      Fiyat_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toDecimal(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisparsiyeldetayv2_866548_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      MikroDagitimVar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisparsiyeldetayv2_263000_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      MusteriId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisparsiyeldetayv2_5696_value",
            "value",
            "Get_Tanim_MusteriListe_LTL",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      MusteriSiparisNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisparsiyeldetayv2_54902_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      NakliyeSicaklik_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisparsiyeldetayv2_535525_value",
            "value",
            "Get_NakliyeSicaklik_Liste",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      OnToplamaVar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisparsiyeldetayv2_799352_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      PaletEbat_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisparsiyeldetayv2_516629_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      PaletSayisi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisparsiyeldetayv2_387232_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Tarih_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisparsiyeldetayv2_792514_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      TanimsizUrun_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisparsiyeldetayv2_278003_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      UrunAciklama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisparsiyeldetayv2_170782_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      UrunId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisparsiyeldetayv2_517121_value",
            "value",
            "Get_Tanim_UrunListe",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      VarisNoktasi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisparsiyeldetayv2_315840_value",
            "value",
            "Get_Tanim_MusteriNoktaListe_Target",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      BrutAgirlik_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisparsiyeldetayv2_977468_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      UrunMiktar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisparsiyeldetayv2_45887_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      KoliAdedi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisparsiyeldetayv2_121251_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SiparisParsiyelDetayv2/SiparisParsiyelDetayv2Component_205082_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Siparis_Add_Parsiyelv2 = result?.data.siparis_Add_Parsiyelv2;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.SiparisParsiyelDetayv2Component_205082_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SiparisParsiyelDetayv2Component_205082_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [364603, 886136] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.SiparisParsiyelDetayv2PageInit();
    }
    if (diId == 364603) {
      isErrorOccurred =
        await this.SiparisParsiyelDetayv2Component_830317_onClick1_();
      if (isErrorOccurred) return true;
    }
  }
}
